import React from 'react';
import { SuggestionAutocompleteTextbox } from '../../../FormBuilder/Widgets/SuggestionAutocompleteTextbox';
import { newHeadingBlock } from '../../Heading/HeadingBlock';
import * as styles from './TextFieldEditor.module.css';
import {
  TextFieldBlock,
  updateLabel,
} from 'concepts/Extraction/Blocks/TextField/TextFieldBlock';
import { TemplateBlock } from 'concepts/Extraction/Blocks/BaseBlock';
import { newMultipleChoiceBlock } from 'concepts/Extraction/Blocks/MultipleChoice/MultipleChoiceBlock';
import { useFocusManager } from 'contexts/FocusManager/FocusManager';

export type TextFieldEditorProps = {
  block: TextFieldBlock;
  placeholder?: string;
  onChange: (updatedTextFieldBlock: TemplateBlock) => void;
  onComplete: () => void;
  onRemove: () => void;
};

export default function TextFieldEditor({
  block,
  onChange,
  onComplete,
  placeholder,
}: TextFieldEditorProps): JSX.Element {
  const requestFocus = useFocusManager();

  return (
    <div className={styles.container}>
      <SuggestionAutocompleteTextbox
        value={block.label}
        blockType={block.type}
        placeholder={placeholder || 'Label'}
        onChange={(label) => onChange(updateLabel(block, label))}
        onKeyDown={(event) => {
          switch (event.key) {
            case '-':
              if (block.label == '') {
                event.preventDefault();
                onChange({ ...newMultipleChoiceBlock(''), id: block.id });
                requestFocus(
                  `[data-block-id="${block.id}"] [data-label-input=""]`
                );
              }
              break;
            case '*':
              if (block.label == '') {
                event.preventDefault();
                onChange({ ...newMultipleChoiceBlock(''), id: block.id });
                requestFocus(
                  `[data-block-id="${block.id}"] [data-label-input=""]`
                );
              }
              break;
            case '#':
              if (block.label == '') {
                event.preventDefault();
                onChange({ ...newHeadingBlock(''), id: block.id });
                requestFocus(`[data-block-id="${block.id}"] input`);
              }
              break;
            case 'Enter':
              event.preventDefault();
              onComplete();
          }
        }}
      />
    </div>
  );
}
